import { LanguageQueryKey } from '@shared/components/LanguageSelect';
import { useQueryFetch } from '@shared/hooks/useQueryFetch';
import { UserEntityTypeContext } from '@shared/types/types';

export function useEntityType() {
    return useQueryFetch<UserEntityTypeContext>(
        'idp/Accounts/EntityTypeContext',
        {
            queryKey: [LanguageQueryKey],
        },
    );
}
